import React, { useState } from "react";
import { Col, Form, Row, Tab, Tabs, Modal, Table } from "react-bootstrap";
import toast from "react-hot-toast";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Delete from "../../../Components/Modals/DeleteModal";
import Navbar from "../../../Components/Navbar/Navbar";
import TableTemp from "../../../Components/TableTemplate/Table";
import AdjustmentTable from "./../../Inventory/Adjustment/AdjustmentTable";
import NoDataImg from "../../../Assets/Images/no-data-img.png"
import {
    dateFormat,
    formatDateNoTime,
    formatDate,
    numberFormat,
    refreshPage,
    toastStyle,
    getTodayDate,
    getType,
    TokenExpiry,
    getTodayDateISO,
    getTime
} from "../../../Helpers/Utils/Common"; 
import DatePicker from "react-datepicker";
import { Fragment } from "react";
import Moment from "moment";
import InputError from "../../../Components/InputError/InputError";
import { validatePayrollModal } from './../../../Helpers/Validation/Employees/PayrollValidation';
import { CSVLink, CSVDownload } from "react-csv";
import downloadIcon from "../../../Assets/Images/download_icon.png";

import { getAllEmployees } from "../../../Helpers/apiCalls/employeesApi";
import { getAllBranches } from './../../../Helpers/apiCalls/Manage/Branches';
import { getOvertimeReport, getUndertimeReport, getUndertimeReportBreakdown } from './../../../Helpers/apiCalls/Employees/SchedulerApi';
import { getTime12 } from './../../../Helpers/Utils/Common';

export default function OvertimeReport() {
    let navigate = useNavigate();
    var dateToday = getTodayDate();
    const accountType = getType();
    
    const today = new Date();
    const sevendaysago = new Date();
    sevendaysago.setDate(sevendaysago.getDate() - 7);

    const [inactive, setInactive] = useState(true);
    const [filterConfig, setFilterConfig] = useState({
        employee_id: "",
        employee_name: "",
        date_from: "",
        date_to: "",
        // department: "",
        // employee_type: "",
        user: accountType,
    })
    const [isError, setIsError] = useState({
        employee_id: false,
        payroll_month_from: false,
        payroll_month_to: false,
    });
    const [branches, setBranches] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [showDetails, setShowDetails] = useState(false);
    const [allData, setAllData] = useState([]);
    const [allDataCsv, setAllDataCsv] = useState([]);
    const [totalNet, setTotalNet] = useState("0");
    const [checkedPayments, setCheckedPayments] = useState([]);
    const [selectedTab, setSelectedTab] = useState("submitted");
    const [dailySales, setDailySales] = useState([]);
    const [isClicked, setIsClicked] = useState(false);

     /* delete modal handler */
     const [showDeleteModal, setShowDeleteModal] = useState(false);
     const handleShowDeleteModal = () => setShowDeleteModal(true);
     const handleCloseDeleteModal = () => setShowDeleteModal(false); 
     /* add modal handler */
     const [showAddModal, setShowAddModal] = useState(false);
     const handleShowAddModal = () => setShowAddModal(true);
     const handleCloseAddModal = () => setShowAddModal(false); 

     const [breakdown, setBreakdown] = useState([]);
     const [selectedRow, setSelectedRow] = useState([]);
     const [selectedEmployee, setSelectedEmployee] = useState({
        label: "",
        value: "",
     });
     const [selectedMonthFrom, setSelectedMonthFrom] = useState("");
     const [selectedMonthTo, setSelectedMonthTo] = useState("");
    
    function renderTable() {
        return (
            <Table className="align-middle">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Expected Time In</th>
                        <th>Actual Time In</th>
                        <th>Expected Time Out</th>
                        <th>Actual Time Out</th>
                    </tr>
                </thead>
                <tbody>
                    {breakdown?.map((sched) => {
                        return(
                            <tr>
                            <td>{sched.date}</td>
                            <td>{sched.time_in}</td>
                            <td>{sched.actual_timein}</td>
                            <td>{sched.time_out}</td>
                            <td>{sched.actual_timeout}</td>
                        </tr>
                        )
                    })}
                </tbody>
            </Table>
        );
    }

    // SEARCH USER
    function handleOnSearch(e) {
        const { name, value } = e.target;
        setFilterConfig((prev) => {
            return { ...prev, [name]: value };
        });
    }

    // function handleViewSched(row) {
    //     setSelectedRow(row)
    //     fetchBreakdown()
    // }

    async function fetchEmployees() {
        setEmployees([])

        const response = await getAllEmployees();
        if (response.error) {
            setEmployees([])
        } else {
            let result = response.data.data.map((data) => {
                var employee = data;
                employee.label = data.first_name + " " + data.last_name;
                employee.value = data.id;
                return employee;
            });
            setEmployees([{label: "All Employees", value: ""}, ...result]);
        }
    }

    async function fetchData() {
        setShowLoader(true);
        setAllData([])
        setTotalNet("0")

        const response = await getOvertimeReport(filterConfig);
        
        if (response.error) {
            setAllData([])
        } else {
            var data = response.data.employees.map((bill) => {
                var info = bill;
                info.overtime_rate = numberFormat(bill.overtime_rate)
                return info;
            });
            setAllData(data)

        }
        setShowLoader(false);
    }

    
    // async function fetchBreakdown() {
    //     setBreakdown([])

    //     const response = await getUndertimeReportBreakdown(filterConfig, selectedRow.employee_id);
    //     
    //     if (response.error) {
    //         setBreakdown([])
            
    //         toast.error(response.error.response.data.messages.error, {
    //             style: toastStyle(),
    //         });
    //     } else {
    //         var data = response.data.map((bill) => {
    //             var info = bill;
    //             info.date = bill.actual_timein ? Moment(bill.actual_timein).format("MMM DD, YYYY") : ""
    //             info.time_in = bill.time_in ? getTime(bill.time_in) : ""
    //             info.actual_timein = bill.actual_timein ? getTime(bill.actual_timein) : ""
    //             info.time_out = bill.time_out ? getTime(bill.time_out) : ""
    //             info.actual_timeout = bill.actual_timeout ? getTime(bill.actual_timeout) : ""
                
    //             return info;
    //         });
    //         
    //         setBreakdown(data)
    //         handleShowAddModal()

    //     }
    // }
    // 


    // React.useEffect(() => {
    //     fetchEmployees();
    // }, []);

    React.useEffect(() => {
        fetchData();
    }, [filterConfig]);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"HR REPORTS"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}
                <Row className="mb-3">
                    <Col xs={6}>
                        <h1 className="page-title"> OVERTIME REPORT </h1>
                    </Col>
                    <Col className="d-flex justify-content-end">
                        {/* <input
                            type="text"
                            name="employee_name"
                            placeholder="Search employee name"
                            className="search-bar"
                            onChange={handleOnSearch}
                        ></input> */}
                    </Col>
                </Row>

                <div className="tab-content">
                    {/* filters */}
                    <div className="my-2 px-2 PO-filters d-flex">
                        <span className="me-4 align-middle mt-2 ps-label">
                            Filter By:
                        </span>
                        <Form.Select
                            type="select"
                            className="react-select-container me-2"
                            classNamePrefix="react-select"
                            placeholder="Department..."
                            name="department"
                            value={filterConfig.department}
                            onChange={(e) =>
                                setFilterConfig((prev) => {
                                return { ...prev, department: e.target.value };
                                })
                            }
                            >
                            <option value="">All Department</option>
                            <option value="franchise">Franchise</option>
                            <option value="sales">Sales</option>
                            <option value="purchasing">Purchasing</option>
                            <option value="human_resources">Human Resources</option>
                            <option value="inventory">Inventory and Logistics</option>
                            <option value="admin">Admin</option>
                            <option value="maintenance">Maintenance and Repairs</option>
                            <option value="marketing">Marketing</option>
                            <option value="finance">Finance</option>
                            <option value="commissary">Commissary</option>
                        </Form.Select>

                        <Form.Select
                            type="select"
                            className="react-select-container me-2"
                            classNamePrefix="react-select"
                            placeholder="Employee Type..."
                            name="employee_type"
                            value={filterConfig.employee_type}
                            onChange={(e) =>
                                setFilterConfig((prev) => {
                                return { ...prev, employee_type: e.target.value };
                                })
                            }
                            >
                            <option value="">All Employee Type</option>
                            <option value="service crew">Service Crew</option>
                            <option value="office staff">Office Staff</option>
                            <option value="department head">Department Head</option>
                            <option value="driver">Driver</option>
                            <option value="warehouse staff">Warehouse Staff</option>
                            <option value="commissary staff">Commissary Staff</option>
                        </Form.Select>
                    </div>


                    <div className="below">
                        {/* table */}
                        <TableTemp
                            tableHeaders={[
                                "EMPLOYEE NAME",
                                "OT HOURS",
                                "OT PAY",
                            ]}
                            headerSelector={[
                                "employee_name",
                                "overtime_hours",
                                "overtime_rate",
                            ]}
                            tableData={allData}
                            showLoader={showLoader}
                        />
                    </div>
                    <div className="mb-2" />
                </div>
            </div>

            <Modal show={showAddModal} onHide={handleCloseAddModal} size="xl" centered>
                <Modal.Body>
                    <span className="PI-modal-header">
                        VIEW SCHEDULE
                    </span>
                    <div className="PI-modal-body mt-3">
                        <Row className="mt-3 mb-2">
                            {/* <span className="PI-modal-label">Original Schedule</span> */}
                            <div className="print-table w-95 mt-3 mx-3">
                                {renderTable()}
                            </div>
                        </Row>
                        
                    </div>
                </Modal.Body>
                <Modal.Footer className="PI-modal-buttons">
                    <button
                        type="button"
                        onClick={handleCloseAddModal}
                        className="button-secondary"
                    >
                        Close
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
